export { default } from './FactsGridBlock';
